module.exports = __webpack_public_path__ + "static/media/clock.db7e5a2e.svg";